import { type ApplicationState } from '../store';

export const getSnackbarStore = (state: ApplicationState) => state.snackbar;
